<footer class="bg-praxis-secondary p-lg-5 p-3">
  <div class="d-flex flex-row">
    <app-contact></app-contact>
  </div>
  <div class="d-flex flex-row-reverse">
    <a routerLink="/impressum" class="p-2">Impressum</a>
    <a routerLink="/datenschutz" class="p-2">Datenschutz</a>
  </div>
</footer>
